"use strict";

/**
 * Clase `Payment` para gestionar las transacciones hacia la plataforma de pagos ePayco.
 */
export class Payment {
    /**
     * Crea una instancia de la clase Payment.
     * @param {Object} notification - Objeto para manejar notificaciones.
     * @param {Object} httpError - Objeto para manejar errores HTTP.
     */
    constructor(notification, httpError) {
        this.notification = notification;
        this.httpError = httpError;
    }

    /**
     * Permite al usuario elegir el método de pago.
     */
    chooseMethod() {
        document.querySelectorAll(".btnPayment").forEach((item) => {
            item.addEventListener("click", async () => {
                const applicationId = item.dataset.id;

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton:
                            "inline-flex w-full mx-1 px-3 py-1 text-sm font-bold text-white duration-300 bg-blue-600 border border-blue-700 rounded-md hover:scale-105 md:w-auto",
                        cancelButton:
                            "inline-flex w-full mx-1 px-3 py-1 text-sm font-bold text-white duration-300 bg-green-600 border border-green-700 rounded-md hover:scale-105 md:w-auto",
                    },
                    buttonsStyling: false,
                });

                try {
                    swalWithBootstrapButtons
                        .fire({
                            imageUrl:
                                "https://multimedia.epayco.co/epayco-landing/btns/epayco-logo-fondo-oscuro-lite.png",
                            imageAlt: "epayco",
                            title: "Elija el método de pago",
                            showCancelButton: true,
                            confirmButtonText: "Pago en efectivo",
                            cancelButtonText:
                                "Pago con tarjeta crédito/débito, pse",
                            reverseButtons: true,
                        })
                        .then((result) => {
                            if (result.isConfirmed) {
                                this.start(applicationId, "agregador");
                            } else if (
                                result.dismiss === Swal.DismissReason.cancel
                            ) {
                                this.start(applicationId, "gateway");
                            }
                        });
                } catch (error) {
                    this.httpError.handleHttpError(error);
                }
            });
        });
    }

    /**
     * Inicia el proceso de pago para una solicitud específica.
     * @param {string} applicationId - ID de la solicitud.
     * @param {"agregador"|"gateway"} type - Tipo de integración de ePayco.
     */
    async start(applicationId, type) {
        try {
            const response = await axios.post(
                `/payments/store/${applicationId}/${type}`
            );

            const { sessionId } = response.data;

            if (!sessionId) {
                console.error("Error al obtener la session de la pasarela");
                return;
            }

            const checkout = ePayco.checkout.configure({
                sessionId,
                type: "onpage",
            });

            checkout.onCreated(() => console.log("Checkout creado"));
            checkout.onErrors((e) => console.error("Error de ePayco:", e));
            checkout.onClosed(() => console.log("Checkout cerrado"));

            /** Dispara el evento que muestra la pasarela */
            checkout.open();
        } catch (error) {
            this.httpError.handleHttpError(error);
        }
    }
}
